<div class="upsell-container">
    <div class="interstitial-page-container">
        <div class="dynamic-loader-wrapper">
            <svg class="progress-ring" width="120" height="120">

        <defs>
          <linearGradient id="loaderGradient" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stop-color="#8B5CF6" />
            <stop offset="100%" stop-color="#A3E635" />
          </linearGradient>
        </defs>
        <circle
          class="progress-ring__circle-bg"
          stroke="#E5E7EB"
          stroke-width="4"
          fill="transparent"
          r="52"
          cx="60"
          cy="60"
        />

        <circle
          class="progress-ring__circle upsell-dynamic-loader-bar"
          stroke="url(#loaderGradient)"
          stroke-width="4"
          fill="transparent"
          r="52"
          cx="60"
          cy="60"
          stroke-linecap="round"
        />
      </svg>
            <svg class="checkmark" viewBox="0 0 24 24" width="38" height="38">
        <path
          fill="none"
          stroke="#7C3AED"
          stroke-width="3.5"
          stroke-linecap="round"
          stroke-linejoin="round"
          d="M5 13l4 4L19 7"
        />
      </svg>
        </div>

        <div class="card-content">
            <span class="badge">REQUEST RECEIVED</span>

            <p class="subtitle">Need financing for your home services project?</p>

            <h2 class="title">loanDepot Can Turn Your Home<br>Equity into Cash!</h2>
            <div class="status-row">
              <a href="#" class="link-primary">Preparing your next step </a>
              <span class="dots"><span></span><span></span><span></span></span>
            </div>
        </div>
        <div class="interstitial-card-footer">
            <p class="secure-text">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M12 2l8 4v6c0 5-4 8-8 10-4-2-8-5-8-10V6l8-4z" stroke="#9ca3af" stroke-width="1.6"></path></svg>
                 Your information is encrypted and is safe.
            </p>

            <div class="logo-container">
                <div class="logo-container-img"></div>
            </div>
        </div>
    </div>
</div>